import styled from 'styled-components';

const Button = styled.button`
	background-color: hsl(210, 58%, 33%);
	border: 1px solid hsl(210, 58%, 33%);
	color: #fff;
	cursor: pointer;
	margin: 0 auto;
	max-width: 300px;
	padding: 0.5rem;
	text-align: center;
	text-decoration: none;
	transition:
		background-color 0.1s ease-in,
		border 0.1s ease-in,
		color 0.1s ease-in,
		font-weight 0.1s ease-in;

	&:hover {
		background-color: hsl(210, 61%, 22%);
		border: 1px solid hsl(210, 58%, 33%);
		font-weight: 700;
	}
`;

export default Button;
